// extracted by mini-css-extract-plugin
export var footer = "_rq-0";
export var inherit = "_rq-1";
export var input = "_rq-2";
export var modalContent = "_rq-3";
export var quillEditor = "_rq-4";
export var subtitle = "_rq-5";